import type React from 'react';
import { Link } from 'react-router';

import studentLogo from 'assets/images/logotype/Logo_Ychenick_Orange.svg';
import teacherLogo from 'assets/images/logotype/Logo_Repetitor_Blue.svg';

import styles from './MobileDrawer.module.scss';

type DrawerLogoAccent = 'student' | 'teacher';

type DrawerLogoProps = {
  accent: DrawerLogoAccent;
  onNavigate?: () => void;
};

const config: Record<
  DrawerLogoAccent,
  { to: string; logo: string; badgeClass: string }
> = {
  student: {
    to: '/profile/tasks',
    logo: studentLogo,
    badgeClass: styles['drawerLogo__badge--student'],
  },
  teacher: {
    to: '/teacher/search',
    logo: teacherLogo,
    badgeClass: styles['drawerLogo__badge--teacher'],
  },
};

export const DrawerLogo: React.FC<DrawerLogoProps> = ({ accent, onNavigate }) => {
  const { to, logo, badgeClass } = config[accent];

  return (
    <Link to={to} className={styles.drawerLogo} onClick={onNavigate}>
      <img src={logo} alt='MyTeacher.pro' className={styles.drawerLogo__image} />
      <div className={styles.drawerLogo__content}>
        <span className={styles.drawerLogo__title}>MYTEACHER</span>
        <span className={`${styles.drawerLogo__badge} ${badgeClass}`}>PRO</span>
      </div>
    </Link>
  );
};
